class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.sticking = false;
    this.setHeightVariables = this.setHeightVariables.bind(this);
  }

  // --header-space reserves the header's in-flow height, so it's only measured while unstuck:
  // measuring the stuck header would shrink it and shift the whole page. --header-height is the bar
  // that stays on screen once scrolled, for scroll offsets.
  setHeightVariables() {
    const { style } = document.documentElement;

    if (!this.sticking) {
      style.setProperty(
        "--header-space",
        `${this.getBoundingClientRect().height}px`,
      );
    }

    style.setProperty("--header-height", `${this.below.offsetHeight}px`);
  }

  connectedCallback() {
    // Using connectCallback due to Shopify window events and observers not disconnecting properly in Shopify editor.
    this.targets = document.querySelectorAll("[data-header-target]");
    this.below = this.querySelector(".header__below");

    window.requestAnimationFrame(() => this.setHeightVariables());
    window.addEventListener("resize", this.setHeightVariables);

    this._initObserver();
  }

  _initObserver() {
    const cb = (entries) => {
      entries.forEach((entry) => {
        if (entry.target.dataset.headerTarget === "stick") {
          this.sticking = !entry.isIntersecting;
          this.classList.toggle("sticking", this.sticking);
          document.body.classList.toggle("header--sticking", this.sticking);
          this.setHeightVariables();
        }
      });
    };

    this.observer = new IntersectionObserver(cb, { threshold: 0 });
    this.targets.forEach((target) => this.observer.observe(target));
  }

  disconnectedCallback() {
    // Using disconnectedCallback due to Shopify window events and observers not disconnecting properly in Shopify editor.
    if (this.observer) {
      this.observer.disconnect();
    }

    window.removeEventListener("resize", this.setHeightVariables);
    document.body.classList.remove("header--sticking");
  }
}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
